"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const types_1 = require("./types");
const uinode_1 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_1.file_financialData.isIntermediateRecord(tape), `intermediateToUINodes: expected ${types_1.artifactType} but found [artifactType:${tape.type}]`);
    const { id: tapeBuilderNodeId, 
    // *** UI configuration setup ***
    artifactSlug, creditFacilitySlug, configuration, } = tape;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            creditFacilitySlug,
            ...configuration,
        },
    };
    return {
        operationNode: null,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node } = params;
    (0, common_1.finleyAssert)(uinode_1.file_financialData.isNode(node), `uiNodesToIntermediate: node is not a generatedFinancialData [nodeType:${node.metadata.tapeBuilderNodeType}]`);
    const { artifactSlug, creditFacilitySlug, ...configuration } = node.configuration;
    const record = {
        id: node.metadata.tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug: null,
        externalFilename: null,
        configuration,
    };
    return {
        record,
        operationNode: null,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map